import packageJson from '../../package.json';

interface PackageJson {
  homepage?: string;
}

const homepage = (packageJson as PackageJson).homepage || undefined;

export const isCommandCenter = homepage ? homepage.indexOf('cms') > -1 : false;
